/* eslint-disable no-unused-expressions */

import React, { useEffect, useState } from 'react'

import { FcFrame, FcSalesPerformance } from 'react-icons/fc'
import { useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { scroller, Element } from 'react-scroll'

import { ReactComponent as DeliveryMinTotalIcon } from '@kolayyolla/common/images/deliveryMinTotal.svg'
import { SortBy } from '@kolayyolla/common/utils/enums'
import { defaultPaymentTypes } from '@kolayyolla/common/utils/globalVars'

import { ArrowBackIosNewOutlined, ArrowForwardIosOutlined, CloseOutlined, FiberManualRecord, LocalDining, Payment } from '@mui/icons-material'
import { Chip, IconButton, Slider, Box, Popper, Button, FormControl, Select, MenuItem } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: 13,
    padding: theme.spacing(2, 1)
  },

  popperBox: {
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 'medium',
    width: 350,
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
  },

  filterHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: '"left right"',

    '& .left': {
      gridArea: 'left'
    },

    '& .right': {
      gridArea: 'right',
      justifySelf: 'end'
    }
  },
  scrollable: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    borderRadius: theme.spacing(2),
    whiteSpace: 'nowrap',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    MsOverflowStyle: '-ms-autohiding-scrollbar',

    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 10,
    backgroundColor: '#fff',
    boxShadow: '1px 1px 10px rgba(0,0,0,0.4)'
  },
  forwardButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 10,
    backgroundColor: '#fff',
    boxShadow: '1px 1px 10px rgba(0,0,0,0.4)'
  }
}))
let isFirst     = true

const HorizontalFilters = () => {
  const classes    = useStyles()
  const navigate   = useNavigate()
  const location   = useLocation()
  const categories = useSelector((state) => state.category.data)

  const [category, setCategory]     = useState('')
  const [sortBy, setSortBy]         = useState(SortBy.DISTANCE)
  const [canOrder, setCanOrder]     = useState(false)
  const [showArrows, setShowArrows] = useState(false)

  const [minRate, setMinRate]                 = useState(10)
  const [minTotal, setMinTotal]               = useState(50)
  const [minRateDisplay, setMinRateDisplay]   = useState(10)
  const [minTotalDisplay, setMinTotalDisplay] = useState(50)

  const [anchorEl, setAnchorEl] = useState(null)

  const [paymentType, setPaymentType]               = useState('any')
  const [loyaltyActive, setLoyaltyActive]           = useState(false)
  const [tableLoyaltyActive, setTableLoyaltyActive] = useState(false)
  const [searchQuery, setSearchQuery]               = useState('')

  useEffect(() => {
    const urlQuery = {}

    if (canOrder) urlQuery.online = canOrder

    if (loyaltyActive) urlQuery.loyalty = loyaltyActive

    if (tableLoyaltyActive) urlQuery.table = tableLoyaltyActive

    if (minTotal < 50 && minTotal > 0) urlQuery.mintotal = minTotal

    if (minRate > 10) urlQuery.minrate = minRate

    if (paymentType !== 'any') urlQuery.payment = paymentType

    if (sortBy !== SortBy.DISTANCE) urlQuery.sort = sortBy

    if (category) urlQuery.category = category

    if (searchQuery) urlQuery.q = searchQuery

    if (isFirst) {
      isFirst = false
    } else {
      navigate({
        pathname: location.pathname,
        search: new URLSearchParams(urlQuery).toString(),
        hash: location.hash
      })
    }
  },
  [canOrder, category, loyaltyActive, tableLoyaltyActive, minTotal, minRate, paymentType, sortBy, searchQuery])

  useEffect(() => {
    const query = new URLSearchParams(location.search)

    query.get('category') ? setCategory(query.get('category')) : setCategory('')
    query.get('q') && setSearchQuery(query.get('q'))
    query.get('online') && setCanOrder(query.get('online') === 'true')

    query.get('loyalty') && setLoyaltyActive(query.get('loyalty') === 'true')
    query.get('table') && setTableLoyaltyActive(query.get('table') === 'true')
    query.get('payment') && setPaymentType(query.get('payment'))
    query.get('sort') && setSortBy(query.get('sort'))

    if (query.get('mintotal')) {
      setMinTotal(query.get('mintotal'))
      setMinTotalDisplay(query.get('mintotal'))
    } else {
      setMinTotal(50)
      setMinTotalDisplay(50)
    }

    if (query.get('minrate')) {
      setMinRate(query.get('minrate'))
      setMinRateDisplay(query.get('minrate'))
    } else {
      setMinRate(10)
      setMinRateDisplay(10)
    }
  }, [location.search])

  const scrollTo = (id) => {
    scroller.scrollTo(id, {
      duration: 700,
      delay: 0,
      smooth: true,
      horizontal: true,
      containerId: 'filtersTab'
    })
  }

  const handleCanOrderClick = () => {
    setCanOrder(prev => !prev)
    setShowArrows(false)
    scrollTo('canOrderFilterBtn')
  }

  const handleTableFilterClick = () => {
    setTableLoyaltyActive(prev => !prev)
    setShowArrows(false)
    scrollTo('tableFilterBtn')
  }

  const handlePopperFilterClick = (event) => {
    setAnchorEl(anchorEl === event.currentTarget ? null : event.currentTarget)
    setShowArrows(false)
    console.log(event.target)
    scrollTo(event.target.name)
  }

  const handleMinTotalClick = (event) => {
    setAnchorEl(anchorEl === event.currentTarget ? null : event.currentTarget)
    setShowArrows(false)
    scrollTo('minTotalFilterBtn')
  }

  const handlePaymentTypeClick = (event) => {
    setAnchorEl(anchorEl === event.currentTarget ? null : event.currentTarget)
    setShowArrows(false)
    scrollTo('paymentTypeFilterBtn')
  }
  const handleCategoryClick    = (event) => {
    setAnchorEl(anchorEl === event.currentTarget ? null : event.currentTarget)
    setShowArrows(false)
    scrollTo('categoryFilterBtn')
  }

  const popperTitle = (name) => {
    switch (name) {
      case 'minRateFilterBtn':
        return 'Min. Biriktiren Sipariş Oranı'
      case 'minTotalFilterBtn':
        return 'Min. Sepet Tutarı'
      case 'paymentTypeFilterBtn':
        return 'Ödeme Şekli'
      case 'categoryFilterBtn':
        return 'Mutfak Tipi'
      default:
        return ''
    }
  }

  return (
    <Box className={classes.root}>

      <div style={{ position: 'relative' }} onMouseEnter={() => setShowArrows(true)} onMouseLeave={() => setShowArrows(false)}>
        <IconButton
          className={classes.backButton}
          style={showArrows ? {} : { display: 'none' }}
          size="small"
          onClick={() => scrollTo('canOrderFilterBtn')} >
          <ArrowBackIosNewOutlined />
        </IconButton>

        <IconButton
          className={classes.forwardButton}
          style={showArrows ? {} : { display: 'none' }}
          size="small"
          onClick={() => scrollTo('paymentTypeFilterBtn')}
        >
          <ArrowForwardIosOutlined />
        </IconButton>

        <div id="filtersTab" className={classes.scrollable}>

          <Element id="canOrderFilterBtn" name="canOrderFilterBtn" >
            <Chip label="Şuan Açık"
              name="canOrderFilterBtn"
              onClick={handleCanOrderClick}
              color={canOrder ? 'primary' : 'default'}
              icon={<FiberManualRecord style={{ color: canOrder ? '#c1f3d9' : '#ccc' }} />} />
          </Element>

          <Element id="tableFilterBtn" name="tableFilterBtn" >
            <Chip label="Sadece Masa"
              name="tableFilterBtn"
              onClick={handleTableFilterClick}
              color={tableLoyaltyActive ? 'primary' : 'default'}
              icon={<FcFrame />} />
          </Element>

          <Element id="minRateFilterBtn" name="minRateFilterBtn" >
            <Chip label={`KumPara Oranı${minRate !== 10 ? `: %${minRate}` : ''}`}
              name="minRateFilterBtn"
              onClick={handlePopperFilterClick}
              color={minRate !== 10 ? 'primary' : 'default'}
              icon={<FcSalesPerformance sx={{ h: 24, w: 24, p: 2, m: 2 }}
              />} />
          </Element>

          <Element id="minTotalFilterBtn" name="minTotalFilterBtn" >
            <Chip label={`Min Sepet${minTotal !== 50 ? `: ${minTotal}₺` : ''}`}
              name="minTotalFilterBtn"
              onClick={handleMinTotalClick}
              color={minTotal !== 50 ? 'primary' : 'default'}
              icon={<DeliveryMinTotalIcon style={{ height: 24, width: 24, padding: 2, margin: 2 }} />} />
          </Element>

          <Element id="paymentTypeFilterBtn" name="paymentTypeFilterBtn" >
            <Chip label={`${paymentType === 'any' ? 'Ödeme Yöntemi' : defaultPaymentTypes.find(i => i.key === paymentType).name}`}
              name="paymentTypeFilterBtn"
              onClick={handlePaymentTypeClick}
              color={paymentType !== 'any' ? 'primary' : 'default'}
              icon={<Payment />} />
          </Element>

          <Element id="categoryFilterBtn" name="categoryFilterBtn" >
            <Chip label={`${!category ? 'Mutfak Tipi' : categories.find(c => c.key === category)?.name}`}
              name="categoryFilterBtn"
              onClick={handleCategoryClick}
              color={category ? 'primary' : 'default'}
              icon={<LocalDining />} />
          </Element>
        </div>
      </div>

      {anchorEl && (
        <Popper open={Boolean(anchorEl)} anchorEl={anchorEl}>
          <Box className={classes.popperBox}>

            <IconButton sx={{ position: 'absolute', right: 1, top: 8 }} onClick={() => setAnchorEl(null)} variant='contained' size='small'><CloseOutlined /></IconButton>
            {popperTitle(anchorEl.getAttribute('name'))}

            {anchorEl.getAttribute('name') === 'minRateFilterBtn' && (<>
              <Slider
                value={minRateDisplay}
                onChange={(e, v) => setMinRateDisplay(v)}
                onChangeCommitted={(e, v) => setMinRate(v)}
                aria-labelledby="minrate-slider"
                valueLabelDisplay="auto"
                step={5}
                marks
                min={10}
                max={50}
              />
              <Button variant='text' onClick={() => {
                setMinRate(10)
                setAnchorEl(null)
              }}>Sıfırla</Button>
            </>)
            }

            {anchorEl.getAttribute('name') === 'minTotalFilterBtn' && (<>
              <Slider
                value={minTotalDisplay}
                onChange={(e, v) => setMinTotalDisplay(v)}
                onChangeCommitted={(e, v) => setMinTotal(v)}
                aria-labelledby="mintotal-slider"
                valueLabelDisplay="auto"
                step={5}
                marks
                min={0}
                max={50}
                valueLabelFormat={(value) => {
                  return value === 50 ? 'Hepsi' : value
                }}
              />
              <Button variant='text' onClick={() => {
                setMinTotal(50)
                setAnchorEl(null)
              }}>Sıfırla</Button>
            </>)
            }

            {anchorEl.getAttribute('name') === 'paymentTypeFilterBtn' && (<>
              <FormControl variant="standard"
                style={{ width: '100%' }}>
                <Select
                  disableUnderline
                  labelId="paymentType-select-label"
                  id="paymentType-select"
                  value={paymentType}
                  onChange={(e) => { setPaymentType(e.target.value) }}
                >
                  <MenuItem value="any">Hepsi</MenuItem>
                  {
                    defaultPaymentTypes.map((pt) => <MenuItem key={pt.key} value={pt.key}>{pt.name}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </>
            )}

            {anchorEl.getAttribute('name') === 'categoryFilterBtn' && (<>
              <FormControl variant="standard"
                style={{ width: '100%' }}>
                <Select
                  disableUnderline
                  labelId="category-select-label"
                  id="category-select"
                  value={category}
                  placeholder="Mutfak Tipi Seçin"
                  onChange={(e) => { setCategory(e.target.value) }}
                >
                  <MenuItem value={null}>Hepsi</MenuItem>
                  {
                    categories.map((pt) => <MenuItem key={pt.key} value={pt.key}>{pt.name}</MenuItem>)
                  }
                </Select>
              </FormControl>
            </>
            )}

          </Box>
        </Popper>
      )}
    </Box>
  )
}

export default HorizontalFilters
